import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: Policies, search and ask. Started from the lesson page in a
 * new tab; never auto-started. Needs a department with at least one policy
 * document (the lesson is gated to agency officers). The first step asks the
 * officer to open any document, so it works whatever the department uploaded.
 */
const tour: TutorialDefinition = {
  id: "search-and-ask",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Search and ask",
  description: "Open a policy section on its page, then ask the chat a question.",
  triggerRoute: /^\/policies(\/.*)?$/,
  startRoute: "/policies/documents",
  lessonId: "search-and-ask",
  autoStart: false,
  steps: [
    {
      target: sel("policyDocRow"),
      waitFor: sel("policyDocRow"),
      waitTimeoutMs: 10000,
      title: "Open a document",
      content: "Click any document. The search box above the list narrows it by title or topic.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: { selector: sel("policyDocRow"), event: "click" },
      hint: "Open a document to continue",
      spotlightClicks: true,
    },
    {
      target: sel("policyOutlineFilter"),
      waitFor: sel("policyOutlineFilter"),
      waitTimeoutMs: 10000,
      title: "Find a section",
      content: "Type a topic or a section number to narrow the outline.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("policyOutlineRow"),
      waitFor: sel("policyOutlineRow"),
      title: "Jump to the page",
      content: "Hover a section and its box lights up on the page. Click it and the page jumps there.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("policyDownload"),
      waitFor: sel("policyDownload"),
      title: "The original file",
      content: "Download the document exactly as your department uploaded it.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("policyBack"),
      waitFor: sel("policyBack"),
      title: "Back to Policies",
      content: "Click back, then open the Chat tab.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: { selector: sel("policyBack"), event: "click" },
      hint: "Click Policies to continue",
      spotlightClicks: true,
    },
    {
      target: sel("policiesTabChat"),
      waitFor: sel("policiesTabChat"),
      title: "The Chat tab",
      content: "Answers come only from your department's documents.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: { selector: sel("policiesTabChat"), event: "click" },
      hint: "Open the Chat tab to continue",
      spotlightClicks: true,
    },
    {
      target: sel("chatComposer"),
      waitFor: sel("chatComposer"),
      title: "Ask a question",
      content:
        "Pick a suggested question or type your own, the way it would come up on a call. Click a numbered citation in the answer to open that section on its page.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
